import { Field as ArkField } from "@ark-ui/react";
import { PropsWithChildren } from "react";

import styles from "./field.module.css";

type FieldProps = PropsWithChildren<
  ArkField.RootProps & {
    label?: string;
  }
>;

const Field = ({ children, label, ...props }: FieldProps) => {
  return (
    <ArkField.Root {...props}>
      {label && <ArkField.Label className={styles.label}>{label}</ArkField.Label>}
      {children}
    </ArkField.Root>
  );
};

export default Field;
